export default __webpack_public_path__ + "static/media/featured-gif.5b4742c8.gif";